module.exports = __webpack_public_path__ + "assets/0e8cac59ab358334b32561fe408dbdb8.mp3";